<template>
    <div>
        <Card title="Account Details" read="Show" @read="load()">
            <Input text="Upload" :value="user.upload | formatData" disabled />
            <Input
                text="Download"
                :value="user.download | formatData"
                disabled
            />
            <Input
                text="Time used"
                :value="user.timeUsed | formatMinute"
                disabled
            />
            <Input
                text="Last connected"
                :value="(user.latestHandshake * 1000) | formatTimeDistance"
                disabled
            />
            <hr />
            <Input text="Plan" :value="user.planName" disabled />
            <Input
                text="Balance"
                :value="user.balance | formatCurrency"
                disabled
            />
            <Input
                text="Credit"
                :value="user.credit | formatCurrency"
                disabled
            />
            <div v-if="user.plan">
                <Input
                    v-if="user.plan.timeCap"
                    text="Time cap"
                    :value="user.plan.timeCap | formatMinute"
                    :append="(user.plan.timeCap - user.timeUsed) | formatMinute"
                    disabled
                />
                <Input
                    v-if="user.plan.dataCap"
                    text="Data cap"
                    :value="user.plan.dataCap | formatData"
                    :append="
                        (user.plan.dataCap - user.upload - user.download)
                            | formatData
                    "
                    disabled
                />
                <Input
                    text="Last billed"
                    :value="user.lastBilled | formatTimeDistance"
                    disabled
                />
                <Input
                    text="Next billing date"
                    :value="
                        (parseInt(user.lastBilled) +
                            parseInt(user.plan.billingInterval) * 60000)
                            | formatTimeDistance
                    "
                    disabled
                />
            </div>
            <hr />
            <Input text="Email" :value="user.email" disabled />
            <Input
                text="Access level"
                :value="user.accessLevel | formatAccessLevel"
                disabled
            />
            <Input
                text="Last logged in"
                :value="user.lastLogin | formatTimeDistance"
                disabled
            />
            <Input
                text="2nd last logged in"
                :value="user.last2ndLogin | formatTimeDistance"
                disabled
            />
            <Input
                text="Registered"
                :value="user.registrationDate | formatTimeDistance"
                disabled
            />
        </Card>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import Card from '@/components/general/card'
    import Input from '@/components/form/input'

    export default {
        methods: {
            load() {
                return this.$store.dispatch('user/user/load')
            }
        },
        computed: mapState({
            user: state => state.user.user.user
        }),
        components: {
            Input,
            Card
        }
    }
</script>